import { TransactionType, WalletReportType } from '../../types/wallet.types';
import {
  EarningExplanationResponse,
  IncomeStatus,
  IncomeType,
  NewTransactionResponse,
  SumTransactionVDriveResponse,
  SumTransactionVGrubsResponse,
} from '../../types/api/wallet.types';
import {
  DateRangeParams,
  PaginationParams,
  ResponseType,
} from '../../types/shared.types';
import { api } from '../api';
import {
  TransactionEntity,
  VerifyWithdrawRequest,
  WalletBankV2Response,
  WithdrawRequest,
} from '../../types/partner';

//  /v1/wallet/sum-transactions-vgrubs
export const getPartnerSumTransactionVGrubs = (
  // `incomeStatus` mirrors the same param on new-transactions so the
  // Total Income card matches the rows listed under it.
  params: DateRangeParams<{ incomeStatus?: IncomeStatus }>
) =>
  api.get<ResponseType<SumTransactionVGrubsResponse>>(
    `/v1/wallet/sum-transactions-vgrubs`,
    { params }
  );

export const getPartnerSumTransactionVDrive = (params: DateRangeParams) =>
  api.get<ResponseType<SumTransactionVDriveResponse>>(
    `/v1/wallet/sum-transactions-vdrive`,
    { params }
  );

export const getPartnerAllTransaction = (
  params: PaginationParams &
    DateRangeParams<{
      type: TransactionType;
      incomeStatus?: IncomeStatus;
      incomeType?: IncomeType;
    }>
) =>
  api.get<ResponseType<Array<NewTransactionResponse>>>(
    `/v1/wallet/new-transactions`,
    { params }
  );

// AI-generated, slow (~3-8s on a cold order). Fetch only on user demand.
export const getPartnerEarningExplanation = (orderId: string | number) =>
  api.get<ResponseType<EarningExplanationResponse>>(
    `/v1/wallet/earning-explanation/${orderId}`
  );

export const getPartnerExportReport = (
  params: DateRangeParams<{
    locationsIds?: Array<number>;
    type?: WalletReportType;
  }>
) =>
  api.get<ResponseType<Array<string>>>(`/v1/wallet/export-report`, { params });

export const getPartnerWalletV2 = () =>
  api.get<ResponseType<WalletBankV2Response>>(`/v2/wallet`);

export const partnerResendOtpEmail = (data: WithdrawRequest) =>
  api.post<ResponseType<null>>(`/v2/wallet/resend-otp-email`, data);

export const partnerWithdraw = (data: WithdrawRequest) =>
  api.post<ResponseType<null>>(`/v2/wallet/withdraw`, data);

export const partnerVerifyWithdraw = (data: VerifyWithdrawRequest) =>
  api.post<ResponseType<TransactionEntity>>(`/v2/wallet/verify-withdraw`, data);
